// @ts-nocheck

import { environment } from 'environments';

export const STATUSES = {
  1: 'Active',
  2: 'Deleted',
  5: 'Locked',
  4: 'Locked',
  8: 'Locked - Consent Video Pending',
  16: 'Locked - Login Repeatedly Failed',
  32: 'Locked - Photo Pending',
  64: 'In SLV',
};
export const ROLES = {
  ANONYMOUS: { ID: 1, NAME: 'anonymous user' },
  AUTHENTICATED: { ID: 2, NAME: 'authenticated user' },
  BUSINESS: { ID: 3, NAME: 'business' },
  DOCTOR: { ID: 4, NAME: 'doctor' },
  SUPER: { ID: 5, NAME: 'super' },
  SYSTEM: { ID: 6, NAME: 'system' },
  WEB: { ID: 7, NAME: 'lemonaid web user' },
  LEMONAID_DASHBOARD_USER: { ID: 8, NAME: 'lemonaid dashboard user' },
  QA_USER: { ID: 9, NAME: 'qa user' },
  LAB_RESULTS_PROVIDER: { ID: 10, NAME: 'lab results provider' },
  MAILORDER_PROVIDER: { ID: 11, NAME: 'mailorder provider' },
  STAFF_MANAGER: { ID: 12, NAME: 'staff manager' },
  PHARMACIST: { ID: 13, NAME: 'pharmacist' },
  SUPERVISING_DOCTOR: { ID: 18, NAME: 'supervising doctor' },
  DOCTOR_ADMIN: { ID: 15, NAME: 'doctor admin' },
  BUSINESS_ADMIN: { ID: 16, NAME: 'business admin' },
  STORE_PORTAL_USER: { ID: 22, NAME: 'store portal user' },
  // 1: "anonymous user",
  // 2: "authenticated user",
  // 3: "business",
  // 4: "doctor",
  // 5: "super",
  // 6: "system",
  // 7: "lemonaid web user"
  // 8: "lemonaid dashboard user"
  // 9: "qa user"
  // 10: "lab results provider"
  // 11: "mailorder provider"
  // 12: "staff manager"
  // 13: "pharmacist"
};
export const GENDERS = ['Male', 'Female', 'Mtf', 'Ftm'];

export const USER_TITLES = [
  'Canon',
  'Captain',
  'Dame',
  'Dr',
  'Father',
  'Lady',
  'Lieutenant',
  'Lord',
  'Madam',
  'Major',
  'Master',
  'Miss',
  'Mr',
  'Mrs',
  'Ms',
  'Mx',
  'Professor',
  'Reverend',
  'Sergeant',
  'Sir',
  'Sister',
  'Unknown',
];

export class Users {
  constructor($log, $http, Endpoints, Utils, API_URL) {
    'ngInject';

    Object.assign(this, {
      $log,
      $http,
      Endpoints,
      Utils,
      API_URL,
      STATUSES,
      ROLES,
      GENDERS,
    });
  }

  getRxKeyPair() {
    return this.$http.get(this.Endpoints.users.rxKeyPair);
  }

  createRxKeyPair() {
    return this.$http.post(this.Endpoints.users.rxKeyPair);
  }

  search(query) {
    const queryString = this.Utils.serializeQuery(query); //return this.$http.get(this.Endpoints.users.search + queryString , { loadingText: 'Loading Patients', cache: true });

    return this.$http.get(this.Endpoints.users.search + queryString, {
      loadingText: 'Loading Patients',
      cache: false,
    });
  }

  search_matchedusers(id) {
    //return this.$http.get(this.Endpoints.users.matchedusers.replace(':id', id), { loadingText: 'Loading Patients', cache: true });
    return this.$http.get(this.Endpoints.users.matchedusers.replace(':id', id), {
      loadingText: 'Loading Patients',
      cache: false,
    });
  }

  updateMatchedusers(user_id, matched_user_id, data) {
    return this.$http.put(
      this.Endpoints.users.updateMatchedusers.replace(':id', user_id).replace(':matched_user_id', matched_user_id),
      data,
    );
  }

  getOne(id) {
    return this.$http.get(this.Endpoints.users.one.replace(':id', id), {
      loadingText: `Loading Patient ${id}`,
    });
  } //update the user notification

  updateOptOutNotification(id, data) {
    return this.$http.put(this.Endpoints.users.one.replace(':id', id), data);
  } // STAFF USERS

  getStaffUsers(status) {
    return this.$http.get(this.Endpoints.staffusers.base + status, {
      loadingText: `Loading staff users`,
    });
  }

  getStaffUser(user_id) {
    return this.$http.get(this.Endpoints.staffusers.one.replace(':user_id', user_id), {
      loadingText: `Loading staff user ${user_id}`,
    });
  }

  updateStaffUser(user_id, data) {
    return this.$http.put(this.Endpoints.staffusers.one.replace(':user_id', user_id), data);
  }

  addStaffUserState(user_id, state_code, license_number) {
    return this.$http.put(
      this.Endpoints.staffusers.state.replace(':user_id', user_id).replace(':state_code', state_code),
      {
        license_number: license_number,
      },
    );
  }

  removeStaffUserState(user_id, state_code) {
    return this.$http.delete(
      this.Endpoints.staffusers.state.replace(':user_id', user_id).replace(':state_code', state_code),
    );
  }

  getVideoStatus() {
    return this.$http.get(this.Endpoints.staffusers.getVideoStatus + '?polling=true');
  }

  updateVideoStatus(videoStatus) {
    return this.$http.put(this.Endpoints.staffusers.updateVideoStatus, {
      paused: videoStatus,
    });
  }

  getActiveUsers() {
    return this.$http.get(this.Endpoints.staffusers.getActiveUsers + '?polling=true');
  }

  fetchAssociatedPharmacies(userId) {
    return this.$http.get(this.Endpoints.users.pharmacies.replace(':user_id', userId));
  }

  hasStateLicense(user_id, state_code) {
    return new Promise((resolve, reject) => {
      this.getStaffUser(user_id)
        .then(({ data }) => {
          if (!data || !data.licenses || !data.licenses.length) {
            resolve(false);
          } else {
            var response = false;
            data.licenses.forEach(license => {
              if (state_code === license.state_code) {
                response = true;
              }
            });
            resolve(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  getAllProviderModalities() {
    return this.$http.get(this.Endpoints.providers.base);
  }

  getProviderModalitybyID(user_id) {
    return this.$http.get(this.Endpoints.providers.one.replace(':id', user_id));
  }

  updateProviderModality(user_id, payload) {
    return this.$http.put(this.Endpoints.providers.one.replace(':id', user_id), payload);
  }

  closeUserAccount(user_id) {
    return this.$http.delete(this.Endpoints.users.deleteUser.replace(':user_id', user_id));
  }

  getHistory(user_id, pagination) {
    const query = Object.assign(pagination, {
      user_id,

      // We added these statuses to the Visit History List
      //
      //    LabOrderSent: { NumericValue: 7.0, StringValue: 'Lab Order Sent' },
      //    RemoteRxCreated: { NumericValue: 7.1, StringValue: 'Remote Rx Created' },
      //    RemoteRxSent: { NumericValue: 7.2, StringValue: 'Remote Rx Sent' },
      //    Abandoned: { NumericValue: 9.8, StringValue: 'Abandoned' },

      admin_status: '0.1|2.4|2.5|4.5|4.61|4.7|4.71|4.9|5.1|5.4|5.5|5.6|5.61|5.7|5.71|5.8|5.9|7.0|7.1|7.2|7.7|9.2|9.8|9.9|10',
      paid: 'true',
      sort: 'created',
      order: 'desc',
    });
    const queryString = this.Utils.serializeQuery(query);
    return this.$http.get(`${this.API_URL}/admin/orders${queryString}`);
  }

  getSubscriptions(user_id) {
    return this.$http.get(this.Endpoints.users.subscriptions.replace(':user_id', user_id));
  }

  getDefaultPaymentMethod(user_id) {
    return this.$http.get(this.Endpoints.users.defaultPaymentMethod.replace(':user_id', user_id));
  }

  reprocessPayment(user_id, subscription_charge_id) {
    return this.$http.post(
      this.Endpoints.users.reprocessPayment
        .replace(':user_id', user_id)
        .replace(':subscription_charge_id', subscription_charge_id),
    );
  }

  cancelSubscription(user_id, user_category_subscription_xref_id, payload) {
    return this.$http.put(
      this.Endpoints.users.cancelSubscription
        .replace(':user_id', user_id)
        .replace(':user_category_subscription_xref_id', user_category_subscription_xref_id),
      payload,
    );
  }

  getCancelReasons(type = '') {
    const queryString =
      type === ''
        ? ''
        : this.Utils.serializeQuery({
            type,
          });
    return this.$http.get(this.Endpoints.users.cancelReasons + queryString);
  }

  getPatientNotes(user_id, pagination) {
    var queryString;

    if (pagination) {
      queryString = this.Utils.serializeQuery(pagination) + '&polling=true';
    } else {
      queryString = '?polling=true';
    }

    return this.$http.get(this.Endpoints.users.patientNotes.replace(':id', user_id) + queryString);
  }

  createPatientNote(user_id, data) {
    return this.$http.post(this.Endpoints.users.patientNotes.replace(':id', user_id), data);
  }

  updatePatientNote(user_id, user_note_id, data) {
    return this.$http.put(
      this.Endpoints.users.patientNotesUpdate.replace(':id', user_id).replace(':user_note_id', user_note_id),
      data,
    );
  }

  uploadUserSignature(user_id, data) {
    return this.$http.post(this.Endpoints.staffusers.uploadUserSignature.replace(':user_id', user_id), data);
  }

  getActivity(id, pagination) {
    return this.$http.get(this.Endpoints.users.activity.replace(':id', id) + this.Utils.serializeQuery(pagination), {
      loadingText: 'Loading Activity',
    });
  }

  getNotes(userId, pagination) {
    const qs = this.Utils.serializeQuery(pagination);
    return this.$http.get(`${this.API_URL}/admin/users/${userId}/visitnotes${qs}`);
  }

  toggleTest(id, isTest) {
    const loadingText = `Marking as ${isTest ? 'test' : 'live'} user`;
    return this.$http.put(
      this.Endpoints.users.test.replace(':id', id),
      {
        test: isTest,
      },
      {
        loadingText,
      },
    );
  }

  updateStatus(id, status, shouldLock) {
    const loadingText = `${shouldLock ? 'Locking' : 'Unlocking'} user`;
    return this.$http.put(
      this.Endpoints.users.status.replace(':id', id),
      {
        status,
        on: shouldLock,
      },
      {
        loadingText,
      },
    );
  }

  update(id, payload = {}) {
    if (payload.dob) {
      payload.dob = this.Utils.encodeISODate(payload.dob);
    }

    if (payload.email && !this.Utils.isValidEmail(payload.email)) {
      throw new Error('Invalid Email');
    }

    return this.$http.put(`${this.API_URL}/admin/users/${id}/details`, payload);
  }

  updateUserProperty(id, property, value) {
    return this.$http.put(`${this.API_URL}/admin/users/${id}/property/${property}`, {
      value,
    });
  }

  create(newUser) {
    const payload = angular.copy(newUser);

    if (!this.Utils.isValidEmail(payload.email)) {
      throw new Error('Invalid Email');
    } // throw on necessary defaults

    Object.assign(payload, {
      terms: true,
      dob: this.Utils.encodeISODate(new Date(payload.dob)),
      app: {
        platform: 'PIMS',
        version: '1',
      },
    });
    return this.$http.post(`${this.API_URL}/admin/users`, payload, {
      loadingText: 'Creating User',
    });
  }

  remove() {}
}

Users.$inject = ['$log', '$http', 'Endpoints', 'Utils', 'API_URL'];

export class User {
  constructor(user) {
    Object.assign(this, user);
    this.dob = new Date(this.dob);
  }
}

// window.User = User;
